import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetHome {
  message: string;
  success: boolean;
  result: {
    IS_PREMIUM: boolean,
    artical: [artical],
    course: [course],
    news: [news],
    banner: []
  }
}

interface artical {
  ALWAYS_OPEN: string;
  ARTICAL_CATEGORY: number;
  ARTICAL_CREATID: string;
  ARTICAL_DATE: string;
  ARTICAL_DETAIL: string;
  ARTICAL_END: string;
  ARTICAL_ID: string;
  ARTICAL_ORIGINAL: string;
  ARTICAL_PIC: string;
  ARTICAL_READED: number;
  ARTICAL_START: string;
  ARTICAL_STATUS: number;
  ARTICAL_TITAL: string;
  CREATE_BY: string;
  POLL_ID: string;
}

interface course {
  AVG_POINT: number;
  COUNT_LESSON: number;
  COUNT_REVIEW: number;
  COUNT_VDO: number;
  COURSE_ID: string;
  COURSE_NAME: string;
  COURSE_PIC: string;
  COURSE_PRICE: number;
  COURSE_SPECIALPRICE: number;
  DATE_DIFF: number;
  DULATION: number;
  TEACHER: {
    PERSONAL_DESCRIPTION: string;
    PROFILE_PIC: string;
    USERNAME: string;
  }
  TEACHER_ID: string;
}

interface news {
  ADMIN_CREATEID: string;
  ALWAYS_OPEN: string;
  NEWS_CATEGORY: string;
  NEWS_DATE: Date;
  NEWS_DETAIL: string;
  NEWS_END: string;
  NEWS_ID: number;
  NEWS_PIC: string;
  NEWS_READED: number;
  NEWS_START: string;
  NEWS_STATUS: number;
  NEWS_TITAL: string;
}

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getHome() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetHome>(environment.URL + '/Home/GetHome', { headers: headers });
  }

  getRole() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<any>(environment.URL + '/authen/CheckRole', { headers: headers });
  }
}
